import { CircleMinusIcon } from '../../../../assets/icons/CircleMinusIcon';
import { CircleTickIcon } from '../../../../assets/icons/CircleTickIcon';
import { QuoteCoverageTableContent } from './BenefitsTable.types';

const styles = {
  tableRowBase:
    'grid grid-cols-12 md:p-space-500 gap-y-space-0 gap-x-space-200 border-b-3 border-(--color-neutral-200) last:border-0 ',
  tableRowPill: 'p-space-500 text-center col-span-6 md:col-span-3 self-start md:p-0',
  tableRowCoverage:
    ' pl-space-500 py-space-300 desktop:p-0 border-b-3 border-(--color-neutral-200) col-span-12 md:col-span-6 font-bold text-center md:text-left md:border-0',
  coverage: (included: boolean) =>
    `p-space-100 col-span-3 rounded-sm flex justify-center items-center w-full border-b border-neutral-200 ${included ? 'bg-(--color-success-200) text-success-700' : 'bg-error-250 text-error-700'}`,
};

export const BenefitsTableRow = ({ coverage }: { coverage: QuoteCoverageTableContent }) => (
  <tr className={styles.tableRowBase}>
    <td className={styles.tableRowCoverage}>
      <p className="text-body-strong">{coverage.type}</p>
    </td>

    <td className={styles.tableRowPill}>
      <figure className={styles.coverage(coverage.standard.included)}>
        {coverage.standard.included ? CircleTickIcon() : CircleMinusIcon()}
      </figure>
      <p className="mt-space-200">{coverage.standard.description}</p>
    </td>

    <td className={styles.tableRowPill}>
      <figure className={styles.coverage(coverage.extra.included)}>
        {coverage.extra.included ? CircleTickIcon() : CircleMinusIcon()}
      </figure>
      <p className="mt-space-200">{coverage.extra.description}</p>
    </td>
  </tr>
);
